module.exports = __webpack_public_path__ + "img/clockin-service.3ac33c99.png";